import { useCalendarPickerStyles_unstable } from '../CalendarPicker/useCalendarPickerStyles.styles';
/**
 * @internal
 *
 * Apply styling to the CalendarYear slots based on the state
 */ export const useCalendarYearStyles_unstable = (props)=>{
    'use no memo';
    return useCalendarPickerStyles_unstable(props);
};
